/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_KommentarInputs */

const de__field_kommentar = /** @type {(inputs: _Field_KommentarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentar`)
};

/**

* @param {_Field_KommentarInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_kommentar = /** @type {((inputs?: _Field_KommentarInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_KommentarInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kommentar(inputs)
});